export default __webpack_public_path__ + "static/media/annual-congrats@3x.5cb4c38b.png";